module.exports = __webpack_public_path__ + "img/sumInfoExport.67465f67.png";